import { toRelativeUrl } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';

import { createOktaClient } from './contexts/auth/oktaClient';

type OktaSecurityProps = {
  oktaAuth: ReturnType<typeof createOktaClient>;
  children: ReactElement;
};

function OktaSecurity({ oktaAuth, children }: OktaSecurityProps) {
  const navigate = useNavigate();
  const restoreOriginalUri = async (_oktaAuth: typeof oktaAuth, originalUri?: string) => {
    const relativeUrl = toRelativeUrl(originalUri || '/', window.location.origin);
    navigate(relativeUrl, { replace: true });
  };
  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      {children}
    </Security>
  );
}

export default OktaSecurity;
